<script setup lang="ts">
import { MtdButton, MtdSwipeableCard, MtdTypography } from '@paygine/mtd-uikit'

import { EditIcon, SbpIcon, TrashIcon } from '@/shared/icons'

const props = defineProps<{
    active?: boolean
    bank: {
        bankName: string
        id: number
        logoUrl: string
        subtitle: string
    }
    borderless?: boolean
    canDelete?: boolean
    canEdit: boolean
    clickable?: boolean
}>()

const emit = defineEmits<{
    'payMethod:change': []
    'payMethod:delete': []
    'payMethod:update': []
}>()

function handleClick() {
    emit('payMethod:change')
}
</script>

<template>
    <MtdSwipeableCard
        :content-class="[
            'pay-method',
            { _borderless: props.borderless, _active: props.active, _clickable: props.clickable },
        ]"
        :is-active="props.canEdit || props.canDelete"
        @click="handleClick"
    >
        <template #content>
            <div class="pay-method__icon">
                <img
                    :src="props.bank.logoUrl"
                    :alt="props.bank.bankName"
                />
            </div>

            <div class="pay-method__name">
                <MtdTypography
                    tag="span"
                    variant="textbody-2-medium"
                    >{{ props.bank.bankName }}</MtdTypography
                >
                <div class="pay-method__sort">
                    <SbpIcon class="pay-method__sort-icon" />
                    <MtdTypography
                        tag="p"
                        class="pay-method__sbp"
                        variant="textbody-3"
                        >{{ props.bank.subtitle || 'СБП' }}</MtdTypography
                    >
                </div>
            </div>
        </template>

        <template #button>
            <MtdButton
                v-if="props.canEdit"
                size="md"
                variant="main-secondary"
                class="pay-method__edit"
                type="button"
            >
                <EditIcon @click="emit('payMethod:update')" />
            </MtdButton>

            <MtdButton
                v-show="props.canDelete"
                size="md"
                class="pay-method__delete"
                variant="danger-secondary"
                type="button"
                @click.stop="emit('payMethod:delete')"
                ><TrashIcon />
            </MtdButton>
        </template>
    </MtdSwipeableCard>
</template>

<style src="./VPayMethod.scss" lang="scss"></style>
